const playerUIdefaultState = {
  footerButtons: ['development-overview', 'promotions-and-sales-methods'],
};

export default playerUIdefaultState;
